export interface QuickLink {
  key: string;
  label: string;
  href: {
    learner: string;
    educator: string;
  };
  circleBg: string;
  icon: string;
  iconSize?: number;
}

export const QUICK_LINKS: QuickLink[] = [
  {
    key: 'student-central',
    label: 'Student central',
    icon: 'https://aula-landing-page-assets.s3.eu-west-1.amazonaws.com/studentcentral.svg',
    circleBg: '#5D536C',
    href: {
      learner: 'https://www.coventry.ac.uk/student-central/',
      educator: 'https://www.coventry.ac.uk/student-central/',
    },
  },
  {
    key: 'help-centre',
    label: 'Help Centre',
    icon: 'https://aula-landing-page-assets.s3.eu-west-1.amazonaws.com/helpcenter.svg',
    circleBg: '#694AAD',
    href: {
      learner:
        'https://aula.zendesk.com/hc/en-us/articles/360018507399-Contact-the-Product-Support-Team',
      educator:
        'https://aula.zendesk.com/hc/en-us/articles/360018507399-Contact-the-Product-Support-Team',
    },
  },
  {
    key: 'time-table',
    label: 'Time table',
    icon: 'https://aula-landing-page-assets.s3.eu-west-1.amazonaws.com/timetable.svg',
    circleBg: '#43A047',
    href: {
      learner: 'https://webapp.coventry.ac.uk/Timetable-main/',
      educator: '',
    },
  },
  {
    key: 'library',
    label: 'Library',
    icon: 'https://aula-landing-page-assets.s3.eu-west-1.amazonaws.com/library.svg',
    circleBg: '#546E7A',
    href: {
      learner: 'https://libguides.coventry.ac.uk/',
      educator: '',
    },
  },
  {
    key: 'customer-services',
    label: 'Customer services',
    icon: 'https://aula-landing-page-assets.s3.eu-west-1.amazonaws.com/customerservices.svg',

    circleBg: '#f2941f',
    href: {
      learner: '',
      educator: '',
    },
  },
  {
    key: 'aula-top-tips',
    label: 'Aula Top Tips',
    icon: 'https://aula-landing-page-assets.s3.eu-west-1.amazonaws.com/aula.svg',
    circleBg: '#005B6C',
    href: {
      learner: '',
      educator: '',
    },
  },
  {
    key: 'linkedin-learning',
    label: 'Linkedin Learning',
    icon: 'https://aula-landing-page-assets.s3.eu-west-1.amazonaws.com/linkedin.svg?v2',

    circleBg: '',
    href: {
      learner: 'https://www.linkedin.com/learning',
      educator: 'https://www.linkedin.com/learning',
    },
    iconSize: 49,
  },
  {
    key: 'phoenix-plus',
    label: 'Phoenix +',
    icon: 'https://aula-landing-page-assets.s3.eu-west-1.amazonaws.com/phoenix.svg',
    circleBg: '#ffffff',
    href: {
      learner: 'https://coventry.potential.ly/',
      educator: '',
    },
    iconSize: 48,
  },
  {
    key: 'bibliu',
    label: 'Bibliu',
    icon: 'https://aula-landing-page-assets.s3.eu-west-1.amazonaws.com/bibliu.svg',
    circleBg: '#ffffff',
    href: {
      learner: 'https://bibliu.com/',
      educator: 'https://bibliu.com/',
    },
  },
  {
    key: 'spectrum-life',
    label: 'Spectrum Life',
    icon: 'https://aula-landing-page-assets.s3.eu-west-1.amazonaws.com/spectrumlife.svg',
    circleBg: '#ffffff',
    href: {
      learner: 'https://cugroup.spectrum.life/',
      educator: '',
    },
  },
  {
    key: 'teach-coventry',
    label: 'Teach Coventry',
    icon: 'https://aula-landing-page-assets.s3.eu-west-1.amazonaws.com/Teachcoventry.svg',
    circleBg: '#0167CC',
    href: {
      learner: '',
      educator: 'https://teach.coventry.domains/',
    },
  },
];
